"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _initialization = require("../actions/initialization");

var initialState = {
  isInitializing: false
};

var steps = function steps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _initialization.INIT_REQUEST:
      return _extends({}, state, {
        isInitializing: true
      });

    case _initialization.INIT_SUCCESS:
      var _action$data = action.data,
          Locale = _action$data.Locale,
          Companies = _action$data.Companies,
          AppointmentSettings = _action$data.AppointmentSettings,
          AuthId = _action$data.AuthId;
      return _extends({}, state, {
        isInitializing: false,
        Locale: Locale,
        Companies: Companies,
        AppointmentSettings: AppointmentSettings,
        authId: AuthId
      });

    default:
      return state;
  }
};

exports.default = steps;